import {
  Activity,
  EnrollmentPaymentStatus,
  EnrollmentStatus,
  EnrollmentWithPayment
} from '../../../pure-js/types/GrooverTypes'
import { isActivityFree } from '../utils/activityUtils'

export function resolveReturnRegisterStep(
  enrollment: EnrollmentWithPayment,
  activity: Activity,
  selectedActivities: Activity[] = []
): number {
  if (enrollment.paymentStatus === EnrollmentPaymentStatus.Paid) {
    return 5
  }

  if (enrollment.paymentStatus === EnrollmentPaymentStatus.PartlyPaid) {
    return 4
  }

  if (enrollment.status !== EnrollmentStatus.Pending) {
    const activitiesForPricing = enrollment.activities?.length ? enrollment.activities : selectedActivities
    return isActivityFree(activity, activitiesForPricing) ? 5 : 4
  }

  return 3
}
